/**
 * @type {import('@builder.io/sdk/dist/src/builder.class').Component}
 */
import { idConfig } from '@glowforge/builder-components/lib/util/shared-configs';
import { PAGES } from '../../../context/MagicSvgContext/magicSvgReducer';

export default {
  name: 'MagicSvgPageWrapper',
  friendlyName: 'Magic SVG Pages',
  image: 'https://cdn.builder.io/api/v1/image/assets%2F69fac0673d2644f0a0a962e1cb3045ef%2Fd2a3493bdd2c4701bd15df06f3b5dd61',
  description: 'Renders different pages based on the Magic SVG state',
  noWrap: true,
  inputs: [
    idConfig,
    {
      name: 'overridePage',
      type: 'boolean',
      helperText: 'Overrides in builder mode to show different pages',
    },
    {
      name: 'overriddenPage',
      type: 'string',
      enum: [PAGES.LANDING, PAGES.GENERATE, PAGES.RESULT],
      showIf: (options) => options.get('overridePage'),
    },
    {
      name: 'forceInsufficientTokenMessage',
      type: 'boolean',
      defaultValue: false,
      helperText: 'Force insufficient token message to be shown in builder edit view',
    },
    {
      name: 'generateButtonContent',
      type: 'uiBlocks',
      hideFromUI: false,
      helperText: 'Text of the generate button',
      defaultValue: [
        {
          '@type': '@builder.io/sdk:Element',
          component: {
            name: 'Text',
            options: {
              text: 'Generate',
            },
          },
        },
      ],
    },
    {
      name: 'deliverButtonContent',
      type: 'uiBlocks',
      hideFromUI: false,
      helperText: 'Text of the deliver button',
      defaultValue: [
        {
          '@type': '@builder.io/sdk:Element',
          component: {
            name: 'Text',
            options: {
              text: 'Deliver',
            },
          },
        },
      ],
    },
    {
      name: 'regenerateMessage',
      type: 'uiBlocks',
      hideFromUI: false,
      helperText: 'Text of the deliver button',
      defaultValue: [
        {
          '@type': '@builder.io/sdk:Element',
          component: {
            name: 'Text',
            options: {
              text: 'Craft Coins Will be redeemed',
            },
          },
        },
      ],
    },
    {
      name: 'regenerateButtonContent',
      type: 'uiBlocks',
      hideFromUI: false,
      helperText: 'Text of the regenerate button',
      defaultValue: [
        {
          '@type': '@builder.io/sdk:Element',
          component: {
            name: 'Text',
            options: {
              text: 'Regenerate',
            },
          },
        },
      ],
    },
    {
      name: PAGES.LANDING,
      type: 'uiBlocks',
      hideFromUI: false,
      helperText: 'Landing page content',
      defaultValue: [
        {
          '@type': '@builder.io/sdk:Element',
          layerName: 'Landing',
          id: PAGES.LANDING,
          component: {
            name: 'Glowforge:Section',
          },
          children: [
            {
              '@type': '@builder.io/sdk:Element',
              component: {
                name: 'magicSvg',
                options: {}
              },
            }
          ]
        },
      ],
    },
    {
      name: PAGES.GENERATE,
      type: 'uiBlocks',
      hideFromUI: false,
      helperText: 'Generate page content',
      defaultValue: [
        {
          '@type': '@builder.io/sdk:Element',
          layerName: 'Generate',
          component: {
            name: 'Glowforge:Section',
          },
          children: [
            {
              '@type': '@builder.io/sdk:Element',
              component: {
                name: 'magicSvg',
                options: {}
              },
            }
          ]
        },
      ],
    },
    {
      name: PAGES.RESULT,
      type: 'uiBlocks',
      hideFromUI: false,
      helperText: 'Result page content',
      defaultValue: [
        {
          '@type': '@builder.io/sdk:Element',
          layerName: 'Result',
          component: {
            name: 'Glowforge:Section',
          },
          children: [
            {
              '@type': '@builder.io/sdk:Element',
              component: {
                name: 'magicSvg',
                options: {}
              },
            }
          ]
        },
      ],
    },
    {
      name: 'insufficientTokenModalId',
      type: 'string',
      helperText: 'id of a builder modal that is shown when insufficient tokens are detected',
    }
  ],
};
